export default __webpack_public_path__ + "static/media/660.c18e03b2.png";